import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  CleanTimePayload,
  CleanTimeResponse,
  CleanTimeSingleResponse
} from 'Interfaces/ReferenceInterfaces/CleanTimeInterface';

export const cleanTimeScreenServices = {
  getAllCleanTimes: (page = 1, pageSize = 10000): Promise<CleanTimeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<CleanTimeResponse>(
          `pps/cleaning-times?page=${page}&page_size=${pageSize} `
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getCleanTimeById: (id: number): Promise<CleanTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<CleanTimeSingleResponse>(`pps/cleaning-times/${id}/`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createCleanTime: (cleanTimeData: CleanTimePayload): Promise<CleanTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<CleanTimeSingleResponse>(
          'pps/cleaning-times/',
          cleanTimeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateCleanTime: (
    id: number,
    cleanTimeData: CleanTimePayload
  ): Promise<CleanTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<CleanTimeSingleResponse>(
          `pps/cleaning-times/${id}/`,
          cleanTimeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteCleanTime: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/cleaning-times/${id}/`);
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  }
};
